import React from "react";
import { Toaster } from "react-hot-toast";
import { REGISTRATION_TOAST_DURATION_MS } from "../utils/registrationToasts";
import "../styles/bulandiRegistrationToasts.css";

export function AppRegistrationToaster() {
  return (
    <Toaster
      position="top-right"
      gutter={12}
      containerClassName="bul-reg-toast-host"
      toastOptions={{
        duration: REGISTRATION_TOAST_DURATION_MS,
      }}
    />
  );
}
